import { Button, Dialog, DialogActions, DialogContent, Divider, Fab, Grid, IconButton } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Utils from '../../providers/Utils';
import ListaEmailuri from './ListaEmailuri';

//comment git
export default class AdaugaEmailuri extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            maxClienti: 10
        }
    }

    componentDidMount() {
    }

    u = new Utils()
    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'md'}
                >

                    <DialogActions >
                        <Fab onClick={this.props.dialogClose}
                            className="pm-round-button-dialog"
                            style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
                        >
                            <i style={{ color: 'black', fontSize: 28, fontWeight: 500 }} className='material-icons'>close</i>
                        </Fab>
                    </DialogActions>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <h5 className='evaluare-noua-subtitlu' >{this.dictionary.evaluari.selecteazaSauAdaugaClienti}</h5>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span style={{ fontSize: 12 }}> {this.dictionary.evaluari.selecteazaSauAdaugaClientiMessage}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Divider style={{ marginTop: 20 }} />
                                    </Grid>

                                </Grid>

                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <h5 className='evaluare-noua-subtitlu'  >{this.dictionary.evaluari.clientiSelectati}</h5>
                                            </Grid>


                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <Grid style={{
                                                    padding: 10,
                                                    borderRight: '1px solid #e0e0e0',
                                                    maxWidth: '95%'
                                                }} container>
                                                    <Grid style={{ height: 500, overflow: 'scroll' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <ListaEmailuri
                                                            emailuri={this.props.emailuriEvaluare}
                                                            eamiluriToate={false}
                                                            deleteEmail={this.props.deleteEmail}
                                                        />
                                                    </Grid>
                                                    <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <span><span style={{ fontWeight: 600 }}>{this.props.emailuriEvaluare.length}</span> {this.dictionary.evaluari.din} {this.state.maxClienti} {this.dictionary.evaluari.clientiEvaluatoriAdaugati}</span>
                                                    </Grid>
                                                </Grid>


                                            </Grid>

                                        </Grid>

                                    </Grid>
                                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <h5 className='evaluare-noua-subtitlu'  > {this.dictionary.evaluari.adaugaManualClienti}</h5>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid container>
                                                    <Grid style={{ display: 'flex', alignItems: 'center' }} item xs={5} sm={5} md={5} lg={5} xl={5}>
                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                            <input
                                                                id='nume_prenume_email'
                                                                style={{ width: '90%' }}
                                                                className='add-project-input'
                                                                type="text"
                                                                margin="normal"
                                                                name='nume'
                                                                value={this.props.email.nume || ''}
                                                                placeholder={this.dictionary.evaluari.numeSiPrenume}
                                                                onChange={this.props.changeEmail}

                                                            />




                                                            <label className='inputLabelPM' htmlFor='nume_prenume_email'>{this.dictionary.evaluari.numeSiPrenume}</label>

                                                        </div>
                                                    </Grid>
                                                    <Grid style={{ display: 'flex', alignItems: 'center' }} item xs={5} sm={5} md={5} lg={5} xl={5}>
                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                            <input
                                                                id='nume_prenume_email'
                                                                style={{ width: '90%' }}
                                                                className='add-project-input'
                                                                type="text"
                                                                margin="normal"
                                                                name='email'
                                                                value={this.props.email.email || ''}
                                                                placeholder={this.dictionary.evaluari.adresaEmail}
                                                                onChange={this.props.changeEmail}

                                                            />




                                                            <label className='inputLabelPM' htmlFor='nume_prenume_email'>{this.dictionary.evaluari.adresaEmail}</label>

                                                        </div>
                                                    </Grid>
                                                    <Grid style={{ display: 'flex', alignContent: 'center' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <IconButton
                                                            style={{ padding: 10, marginTop: 3, backgroundColor: '#19a63c' }}
                                                            aria-controls='simple-menu' aria-haspopup="true" onClick={this.props.adaugaEmail}>
                                                            <i style={{ fontSize: 24, color: 'white' }} className='material-icons'>
                                                                check_circle_outline
                                                                     </i>
                                                        </IconButton>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <h5 className='evaluare-noua-subtitlu' style={{marginBottom:0}} >{this.dictionary.evaluari.selecteazaClientiExistenti} </h5>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <Grid container>
                                                    <Grid style={{ height: 400, overflow: 'scroll' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <ListaEmailuri
                                                            emailuri={this.props.emailuriToate}
                                                            emailuriToate={true}
                                                            selecteazaEmail={this.props.selecteazaEmail}
                                                        />

                                                    </Grid>

                                                    <Grid style={{ margin: '20px 0 20px 0' }} item xs={12} sm={12} md={12} lg={12} xl={12}>


                                                        {this.props.emailuriToate.length > 0 &&
                                                            <Button

                                                               className='add-button-blue' onClick={this.props.adaugaClienti}  >
                                                                <i style={{ marginRight: 10 }} className='material-icons pm-round-button-text'>reply</i>
                                                                      {this.dictionary.evaluari.adaugaClientiSelectati}
                                                                    </Button>
                                                        }


                                                    </Grid>
                                                </Grid>

                                            </Grid>


                                        </Grid>

                                    </Grid>



                                </Grid>

                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Divider style={{ width: '100%' }} />
                            </Grid>

                        </Grid>
                    </DialogContent>

                    <DialogActions style={{ justifyContent: 'flex-start', paddingLeft: 20 }}>
                        <Button

                            className='add-button-green' onClick={this.props.dialogClose}  >

                            {this.dictionary.evaluari.salveazaSiInchide}
                                </Button>

                    </DialogActions>

                </Dialog>
            </div >
        );
    }
}